import api from './api';

const regionService = {
  // Get all regions
  getAll: async () => {
    const response = await api.get('/regions');
    return response.data;
  },

  // Get region by ID
  getById: async (id) => {
    const response = await api.get(`/regions/${id}`);
    return response.data;
  },

  // Get sellers for a region
  getSellers: async (id) => {
    const response = await api.get(`/regions/${id}/sellers`);
    return response.data;
  },

  // Create region (admin only)
  create: async (regionData) => {
    const response = await api.post('/regions', regionData);
    return response.data;
  },

  // Update region (admin only)
  update: async (id, regionData) => {
    const response = await api.put(`/regions/${id}`, regionData);
    return response.data;
  },

  // Delete region (admin only)
  delete: async (id) => {
    const response = await api.delete(`/regions/${id}`);
    return response.data;
  },
};

export default regionService;
